import {createSelector} from 'reselect'
import keyBy from 'lodash/keyBy.js'
import sortBy from 'lodash/sortBy.js'

import {setForm, updateForm, formsSelector, getState} from '../store.js'
import {fetchAllApiverson} from '../common/fetchAll.js'
import {useContactsSelector} from './company.js'
import {getNounsFromValue, tokenizeOptions} from '../common/tokenizeOptions.js'
import {showConfirmMessageModal} from '../common/components/Modal/ConfirmMessageModal.js'
import {buildPath} from '../common/querystring.js'
import apiverson from '../common/apiverson.js'

const CONTACTS = 'contacts'

export function contactsSelector(state) {
  return formsSelector(state)[CONTACTS] || contactsSelector.default
}
contactsSelector.default = {}

export function contactSelector(state, {contactID}) {
  return contactsSelector(state)[contactID]
}

export const contactsSortedByNicknameSelector = createSelector(
  contactsSelector,
  (contacts) => sortBy(contacts, 'nickname'),
)

export const contactOptionsSelector = createSelector(
  contactsSortedByNicknameSelector,
  (contacts) =>
    contacts.map((contact) => ({
      value: contact.id,
      display: contact.nickname,
      entity: contact,
      type: CONTACTS,
      nouns: getNounsFromValue(
        `${contact.nickname} ${contact.address.name || ''} ${
          contact.address.email || ''
        } ${contact.address.email_cc || ''} ${contact.address.email_bcc || ''}`,
      ),
    })),
)

export const contactOptionTokensSelector = createSelector(
  contactOptionsSelector,
  (contactOptions) => tokenizeOptions(contactOptions),
)

export function setContacts(contacts) {
  setForm(CONTACTS, keyBy(contacts, 'id'))
}

export function setContact(contact) {
  updateForm(CONTACTS, {[contact.id]: contact})
}

export async function getContacts() {
  if (!useContactsSelector(getState())) {
    return
  }

  const contacts = await fetchAllApiverson('/contact/', 'contact')

  setContacts(contacts)
}

export async function deleteContact(contactID) {
  await showConfirmMessageModal({
    title: 'Delete Contact',
    Message: () => <div>Are you sure you want to delete this contact?</div>,
    confirmText: 'Delete',
    cancelText: 'Cancel',
    async onResolve({outcome}) {
      if (!outcome) {
        return
      }

      await apiverson.delete(buildPath(['contact', contactID]))

      const contacts = contactsSortedByNicknameSelector(getState())

      setContacts(contacts.filter(({id}) => id !== contactID))
    },
  })
}
